import {CommonMessages} from '../common.messages';

export const MarketDataFeedSubscriptionMessages = {
    CreateMarketDataFeedSubscriptionFailed: {
        key: 'CreateMarketDataFeedSubscriptionFailed',
        message: 'Error while processing request. Unable to create a Market Data Feed Subscription.'
    },
    CreateMarketDataFeedSubscriptionSuccess: {
        key: 'CreateMarketDataFeedSubscriptionSuccess',
        message: 'Market data feed bundle subscription is successfully created.'
    },
    EditMarketDataFeedSubscriptionFailedNoSubscriptionData: {
        key: 'EditMarketDataFeedSubscriptionFailedNoSubscriptionData',
        message: 'You can not edit! There is no subscribed data'
    },
    UpdateMarketDataFeedSubscriptionFailed: {
        key: 'UpdateMarketDataFeedSubscriptionFailed',
        message: 'Error while processing request. Unable to update a Market Data Feed Subscription.'
    },
    UpdateMarketDataFeedSubscriptionFailedNoPermission: {
        key: 'UpdateMarketDataFeedSubscriptionFailedNoPermission',
        message: 'No permission to update subscription.'
    },
    UpdateMarketDataFeedSubscriptionSuccess: {
        key: 'UpdateMarketDataFeedSubscriptionSuccess',
        message: 'Market data feed bundle subscription is successfully updated.'
    },
    ListUnsubscribedMarketDataFailed: {
        key: 'ListUnsubscribedMarketDataFailed',
        message: 'Error while processing request. Unable to list a unsubscribed data.'
    },
    ListTradingAccountFailed: {
        key: 'ListTradingAccountFailed',
        message: 'Error while processing request. Unable to list a trading account data.'
    },
    AlreadySubscribedAllBundle: {
        key: 'AlreadySubscribedAllBundle',
        message: 'The user/account already subscribed to all available bundles. Or there is no bundle to subscribe.'
    },
    ...CommonMessages
};
